//---------------------------------------------
// Load JQuery - Bootstrap 5 uses Vanilla JS
//---------------------------------------------
//import $ from 'jquery';


// =======================================================================
// Load all styles
// =======================================================================
import '../scss/main.scss';


jQuery(document).ready(function($) {

	function pollForGform(callback) {
		if (window.gform && typeof window.gform === 'function') {
			const gform = window.gform;
			callback(gform);
		} else {
			return setTimeout(pollForGform.bind(null, callback), 50);
		}
	}

    pollForGform((gform) => {
		gform.addAction('gform_post_conditional_logic_field_action', function(formId, action, targetId, defaultValues, isInit) {
			if (action == 'show' && $(targetId).hasClass('asterisk')) {
				$('.alert').append($(targetId));
			}
		});
	});
	

});